module.exports = __webpack_public_path__ + "img/146.0474438b.jpg";